import Ajax from '@/libs/Ajax'

// 后台命名空间
const NAME_SPACE = "/aseapi/console/Basics";

export default {
  // 保存基础信息
  saveBasics(param) {
    return Ajax.post(`${NAME_SPACE}/saveBasics`, param)
  },
  // 查询所有基础信息
  doQuery(params){
    return Ajax.get(`${NAME_SPACE}/queryBasics`, { params });
  },
  // 添加本地配置之前  检测用户信息完整性
  handleAddBeforCheck(uuid){
    return Ajax.get(`${NAME_SPACE}/handleAddBeforCheck/${uuid}`)
  },
  saveLocalInfoBefor(uuid,bizuuid){
    return Ajax.get(`${NAME_SPACE}/saveLocalInfoBefor/`,{ params: { uuid: uuid, bizuuid: bizuuid } });
  },
  // 保存本地传输配置
  handleSaveLocalInfo(param){
    return Ajax.post(`${NAME_SPACE}/saveLocalInfo`, param)
  },
  // 删除本地传输配置
  handleDeleteLocalInfo(uuid){
    return Ajax.post(`${NAME_SPACE}/deleteLocalInfo/${uuid}`)
  },
  // 查询本地业务运行列表
  doQueryLocalBiz(params){
    return Ajax.get(`${NAME_SPACE}/queryBizStatus`, { params });
  },
  // 停止业务终端
  startBizRes(uuid){
    return Ajax.post(`${NAME_SPACE}/startbizres/${uuid}`)
  },
  // 停止业务终端
  stopBizRes(uuid){
    return Ajax.post(`${NAME_SPACE}/stopbizres/${uuid}`)
  },
  // 启动所有终端
  startAllRes(){
    return Ajax.get(`${NAME_SPACE}/startallres`)
  },
  // 停止所有终端
  stopAllRes(){
    return Ajax.get(`${NAME_SPACE}/stopallres`)
  },
  // 环境监测
  environmentalTesting(){
    return Ajax.post(`${NAME_SPACE}/environmentaltesting`)
  },
  environmentalTestingLocal(){
    return Ajax.get(`${NAME_SPACE}/environmentaltestinglocal`)
  },
  environmentalTestingDir(){
    return Ajax.get(`${NAME_SPACE}/environmentaltestingdir`)
  },
  environmentalTestingClient(){
    return Ajax.get(`${NAME_SPACE}/environmentaltestingclient`)
  },
  environmentalTestingMQ(){
    return Ajax.get(`${NAME_SPACE}/environmentaltestingmq`)
  },
  environmentalTestingQue(){
    return Ajax.get(`${NAME_SPACE}/environmentaltestingque`)
  },
  // ukey验证
  ukeycheck(pw){
    return Ajax.post(`${NAME_SPACE}/ukeycheck/${pw}`)
  },
  // 参数查询
  queryPara(){
    return Ajax.get(`${NAME_SPACE}/queryPara`)
  },
  // 保存参数
  doSubmitPara(param){
    return Ajax.post(`${NAME_SPACE}/doSavePara`, param)
  },
  // 配置导入
  importConfig(data){
    return Ajax.post(`${NAME_SPACE}/importConfig`, data);
  },
  doGetVersion(){
    return Ajax.get(`${NAME_SPACE}/getVersionNo`);
  },
  isOnlineSupport(){
    return Ajax.get(`/ClientController/isOnlineSupport`);
  },
  doGetBaseInfo(){
    return Ajax.get(`${NAME_SPACE}/getBaseInfo`);
  },
};
